import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import Authentication from '../reducers/auth';
import UserDetails from '../reducers/userDetails';

const createRootReducer = history => combineReducers({
    router: connectRouter(history),
    Authentication,
    UserDetails,
})

export default createRootReducer;
